export function sortByOriginalList(originalList, response) {
    if (!Array.isArray(originalList) || !Array.isArray(response)) {
        return [];
    }
    return originalList.reduce((res, name) => {
        const item = response.find((r) => r.fields.name === name);
        return item ? res.concat(item) : res;
    }, []);
}
